import React from 'react';
import { Container, LinkBtnGold } from './Elements';
import { Heading, Text, Box, Flex } from 'rebass';
import { useSiteContent } from '../content';

const FooterPre = () => {
  const { sivusto } = useSiteContent();

  return (
    <Box
      color={'beigeBg'}
      bg={'blueDark'}
      minHeight={446}
      sx={{
        display: 'none',
        backgroundImage: 'url(' + sivusto.tausta3.url + ')',
        backgroundSize: 'cover',
      }}
    >
      <Container
        minHeight={446}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        color={'beigeText'}
      >
        <Heading my={2} fontSize={6} textAlign="center">
          Tilaratkaisu 48 tunnissa
        </Heading>
        <Text my={2} maxWidth={720} textAlign="center">
          Kiinnostuitko? Laske hinta-arvio ja ota yhteyttä. Saat lopullisen
          tarjouksen kahden arkipäivän sisällä.
        </Text>
        <Flex my={2} justifyContent="center">
          <LinkBtnGold to="/tilaratkaisu/#tila-ja-hinta">
            Laske hinta-arvio
          </LinkBtnGold>
        </Flex>
      </Container>
    </Box>
  );
};

export default FooterPre;
